import React from "react";
import MediaPlayer from "@icarius-common/mediaPlayer";
import { BASE_URL } from "@icarius-connection/endpoints";

const MediaContent = (props) => {

    const {
        data,
    } = props;

    if (!data) return null;

    return (
        <div
            style={{
                width: "100%",
                aspectRatio: data.isAudio ? "" : "16/9",
                height: data.isAudio ? 35 : "",
                overflow: "hidden",
                borderRadius: 15,
            }}
        >
            <MediaPlayer
                url={data.isExternal ? data.path : BASE_URL + data.path}
                isURLToFetchBlob={!data.isExternal}
            />
        </div>
    )
}

export default MediaContent;